import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";

const toKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromKey = (k) => (k ? new Date(`${k}T00:00:00`) : undefined);

// value/onChange use "YYYY-MM-DD" strings (local calendar day).
export const DatePicker = ({ value, onChange, placeholder, testId, disabledBefore }) => {
  const [open, setOpen] = useState(false);
  const selected = fromKey(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="date-picker">
        <PopoverTrigger asChild>
          <button type="button" className="search date-trigger" data-testid={testId}><CalendarDays size={15} />{selected ? selected.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : placeholder}</button>
        </PopoverTrigger>
        {value && <button type="button" className="icon-button" aria-label="Clear date" data-testid={`${testId}-clear`} onClick={() => onChange("")}><X size={14} /></button>}
      </div>
      <PopoverContent className="w-auto p-0 bg-white border shadow-lg z-50" align="start">
        <Calendar mode="single" selected={selected} disabled={disabledBefore ? { before: disabledBefore } : undefined} onSelect={(d) => { onChange(d ? toKey(d) : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
